window.setTimezoneCookie = function() {
  var current_time = new Date();
  console.log(current_time);
  setCookie('time_zone', current_time.getTimezoneOffset());
}